import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {CustomMetricsPageContent} from "./CustomMetricsPageContent";

class CustomMetricsPage extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <CustomMetricsPageContent/>
            </div>
        );
    }
}

export default CustomMetricsPage;
